(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !window.gsap || !window.ScrollTrigger) return;

  window.gsap.registerPlugin(window.ScrollTrigger);
  window.gsap.from('[data-nr-hero] .nr-hero__copy-wrap', { opacity: 0, y: 36, duration: 0.9, ease: 'power3.out' });
  window.gsap.from('[data-nr-hero] .nr-hero__media', { opacity: 0, y: 48, scale: 0.96, duration: 1.1, delay: 0.1, ease: 'power3.out' });

  const story = document.querySelector('[data-nr-story]');
  if (!story) return;
  const frames = story.querySelectorAll('.nr-story__frame');
  frames.forEach((frame) => {
    window.gsap.fromTo(frame, { opacity: 0.45, scale: 0.94 }, {
      opacity: 1,
      scale: 1,
      duration: 0.7,
      ease: 'power3.out',
      scrollTrigger: { trigger: frame, start: 'top 85%', once: true },
    });
  });
})();
